import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { FacilitiesService } from './facilities.service';

@Injectable({
  providedIn: 'root'
})
export class FacilitiesResolve implements Resolve<any> {

  constructor(
    private fs: FacilitiesService,
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    let params = {
      ...route.params,
      ac_group: route.parent.params.id
    }
    return this.fs.updateFacilities(params)
  }
}
